import React from 'react';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { endPoints } from 'api/endpoints';
import axios from 'api/request';
import { useMutation } from 'react-query';
import Select from 'pages/reference-implementation/components/select';
import { OrderPayload } from 'pages/reference-implementation/provisioning/RI003O/store';
import { InputLabel } from 'pages/reference-implementation/components/input-label';

export const ADCertGroup = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [options, setOptions] = React.useState([]);
    const { catalogCode } = useParams();

    const adCertGroupApi = useMutation(() => axios.get(`${endPoints.riServices.COMMON.adCertGroup?.replace('{RID}', catalogCode)}`));

    const setAdCertGroup = (adCertGroup) => {
        setOrder({ ...order, adCertGroup });
    };

    const resetOptions = () => {
        setOptions([]);
    };

    const isExistsInOptions = (adCertGroup) => options.find((option) => adCertGroup === option.value);

    const handleOnSelectChange = (selected) => setAdCertGroup(selected.value);

    React.useEffect(() => {
        if (adCertGroupApi?.isSuccess) {
            setOptions(adCertGroupApi?.data?.data?.map((app) => ({ label: app, value: app })));
        }
    }, [adCertGroupApi?.isSuccess]);

    React.useEffect(() => {
        if (options && options?.length === 1 && !order?.adCertGroup) {
            setOrder({ ...order, adCertGroup: options?.[0].value });
        }
        if (options && options?.length && order?.adCertGroup) {
            const adCertGroup = isExistsInOptions(order?.adCertGroup);
            setOrder({ ...order, adCertGroup: adCertGroup?.value });
        }
    }, [options]);

    React.useEffect(() => {
        resetOptions();
        adCertGroupApi.mutate();
    }, []);

    React.useEffect(() => {
        if (!order?.adCertGroup && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [order?.adCertGroup, order?.isTouched]);
    return (
        <Box display="flex" alignItems="center" gap={1}>
            <Select
                dataTestId="ad-cert-group-auto"
                key="ad-cert-group"
                label={<InputLabel label="Active Directory Certificate Group" isRequired />}
                value={order?.adCertGroup || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                disabled={adCertGroupApi.isLoading}
                isLoading={adCertGroupApi.isLoading}
                isRequired={isTouched}
            />
        </Box>
    );
};

export default React.memo(ADCertGroup);
